


































/** @format */

import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { isEqual } from 'lodash';
import { getSetPositions, setPosition } from '@/api/system-management/index';

@Component({})
export default class transferModal extends Vue {
  // 机构数据 {orgDepId，orgDepName}
  @Prop()
  orgData!: {
    orgDepId: string;
    orgDepName: string;
    parentName: string;
  };

  // 已选中项
  @Prop()
  targetKeys!: string[];

  // 是否展示弹窗
  @Prop({ type: Boolean, default: false })
  visible!: boolean;

  //是否是二级节点
  @Prop({ type: Boolean, default: false })
  isRoot!: boolean;

  //是否继承
  @Prop({ type: Boolean, default: false })
  isInherit!: boolean;
  // 可选数据
  data: any[] = [];
  targetKeysCurrent: string[] = [];
  rootOrgDepName: string = '';

  confirmLoading: boolean = false;
  IsZhengrong: boolean = 'zhengrong,testing,development'.includes(window.VUE_APP_SERVER_CONFIG.APP_ENV); //岗位设置正荣定制化
  @Watch('visible')
  visibleChanged(val: boolean) {
    if (val) {
      this.init();
    }
  }

  async init() {
    this.data = [];
    this.targetKeysCurrent = this.targetKeys.map((item: any) => {
      return item.jobDefinitionsId;
    });
    try {
      const { status, data } = await getSetPositions({
        orgDepId: this.orgData && this.orgData.orgDepId
      });
      const { jobDefinitionsList = [], orgDepName } = data;
      this.data = jobDefinitionsList.map((item: any) => {
        return {
          key: item.jobDefinitionsId,
          title: item.jobDefinitionsName
        };
      });
      this.rootOrgDepName = data.orgDepName || '';
      //如果继承要显示跟节点的名称
      if (this.isInherit && this.IsZhengrong) return (this.rootOrgDepName = this.orgData.parentName);
    } catch (e) {
      this.$message.error('获取当前机构岗位组失败');
    }
  }

  handleChange(targetKeys: any) {
    this.targetKeysCurrent = targetKeys;
  }

  async onSave() {
    // if (!this.targetKeysCurrent || this.targetKeysCurrent.length < 1) {
    //   this.$message.success('请选择岗位')
    //   return false
    // } else if (isEqual(this.targetKeysCurrent, this.targetKeys)) {
    //   this.$emit('ok')
    //   return false
    // }
    if (this.confirmLoading) return false;
    this.confirmLoading = true;
    try {
      const result = await setPosition({
        orgDepId: this.orgData && this.orgData.orgDepId,
        jobDefinitionsIdList: this.targetKeysCurrent.filter(item => item != null)
      });
      this.$message.success('保存成功');
      this.$emit('ok');
    } catch (error) {
      this.$message.error((error && error.msg) || '系统繁忙，请稍后再试');
    } finally {
      this.confirmLoading = false;
    }
  }
}
